<template>
    <div class="baseInfo report">
        <div class="manage-main">
            <div class="rule" style="display: flex;background: #fff;">
                <Menu></Menu>
                <div class="manage-right report-manage">
                    <div class="right-top" style="margin-bottom: 40px;">
                        <div class="head">
                            <div class="left">
                                <div class="select">
                                    <span></span>
                                    <select v-model="dayNumA">
                                        <option value="7">7 日</option>
                                        <option value="15">15 日</option>
                                        <option value="30">30 日</option>
                                    </select>
                                </div>
                                <div class="title">
                                    入住订单统计
                                </div>
                            </div>
                            <div class="right">
                                <div class="date-input date-time" data-type="time"  @click="calendarA.show = true">
                                    <i class="iconfont icon-calendar1"></i>
                                    <input type="text" readonly v-model="StartA" class="date-time">
                                </div>
                                <DatePicker @select="calendarA.select" v-show="calendarA.show" :start="calendarA.start"
                                                :beginDate="calendarA.begin" :endDate="calendarA.end"></DatePicker>
                                
                            </div>
                        </div>
                        <!-- <div class="link"></div> -->
                        <div class="charts">
                            <div class="chart-btn">
                                <span :class="typeA == 'NRC'?'active':''" @click="checkType('NRC','A')">间夜数</span>
                                <span :class="typeA == 'OrderCount'?'active':''" @click="checkType('OrderCount','A')">订单数</span>
                                <span :class="typeA == 'Amount'?'active':''" @click="checkType('Amount','A')">订单金额</span>
                            </div>
                            <ve-line width="930px" :data="chartDataA" :extend="dayNumA==30?extendA:extend" v-if="!isLoadingA&&!isNoDataA" ></ve-line>
                            <div class="loading" v-if="isLoadingA">
                                <Loading :isLoading="isLoadingA"></Loading>
                            </div>
                            <div class="no-data" v-if="isNoDataA">
                                暂无数据...
                            </div>
                        </div>
                    </div>
                    <div class="right-top" style="margin-bottom: 30px;">
                        <div class="head">
                            <div class="left">
                                <div class="select">
                                    <span></span>
                                    <select v-model="dayNumB">
                                        <option value="7">7 日</option>
                                        <option value="15">15 日</option>
                                        <option value="30">30 日</option>
                                    </select>
                                </div>
                                <div class="title">
                                    预订订单统计
                                </div>
                            </div>
                            <div class="right">
                                <div class="date-input date-time" data-type="time"  @click="calendarB.show = true">
                                    <i class="iconfont icon-calendar1"></i>
                                    <input type="text" readonly v-model="StartB" class="date-time">
                                </div>
                                <DatePicker @select="calendarB.select" v-show="calendarB.show" :start="calendarB.start"
                                                :beginDate="calendarB.begin" :endDate="calendarB.end"></DatePicker>
                                
                            </div>
                        </div>
                        <!-- <div class="link"></div> -->
                        <div class="charts">
                            <div class="chart-btn">
                                <span :class="typeB == 'NRC'?'active':''" @click="checkType('NRC','B')">间夜数</span>
                                <span :class="typeB == 'OrderCount'?'active':''" @click="checkType('OrderCount','B')">订单数</span>
                                <span :class="typeB == 'Amount'?'active':''" @click="checkType('Amount','B')">订单金额</span>
                            </div>
                            <ve-line width="930px" :data="chartDataB" :extend="dayNumB==30?extendA:extend"  v-if="!isLoadingB&&!isNoDataB"></ve-line>
                            <div class="loading" v-if="isLoadingB">
                                <Loading :isLoading="isLoadingB"></Loading>
                            </div>
                            <div class="no-data" v-if="isNoDataB">
                                暂无数据...
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const lineExtend = {
  // x 轴标签旋转
  'xAxis.0.axisLabel.rotate': 45,
  legend: { x: 'right' },
  series: {
    // 关键：锁死直线
    smooth: false,
    smoothMonotone: 'none',
    // 颜色 & 线宽
    itemStyle: { color: '#22bf8a' },
    lineStyle: { width: 2 },
    // 节点空心圆
    // symbol: 'circle',
    label: {
  show: true,
  position: 'top',            // 飘在点上方
  distance: 10,                // 离点 8px
  color: '#fff',
  fontSize: 12,
  backgroundColor: '#22bf8a',
  borderRadius: 5,
  padding: [5, 15],
  // 加小三角（指向折线）
  rich: {
    a: {
      backgroundColor: 'inherit',
      borderColor: 'inherit',
      borderWidth: 1,
      borderRadius: 4,
      padding: [4, 8]
    }
  }
},
    symbolSize: 6,
    emphasis: {
      itemStyle: {
        color: 'transparent',
        borderColor: '#22bf8a',
        borderWidth: 2
      }
    }
  }
}
    import DatePicker from './comm/datePicker.vue'//日期
    import Loading from './../../common/cmpnt/Loading/Loading.vue'//缓冲
    import Menu from './../../common/cmpnt/menu/Menu'
    export default {
        name: "reportDay",
        components: {
            Menu,
            Loading,
            DatePicker
        },
        data: function () {
            
            
            this.extendA = lineExtend
            this.extend  = {
  ...lineExtend,
  // 只有 30 日才转 45°
  'xAxis.0.axisLabel.rotate': this.dayNumA === 30 ? 45 : 0
}
            return {
               
                
                chartDataA: {
                    columns: ['日期','间夜数'],
                    rows:[
                        {
                            日期:this.getDate(0),
                            间夜数:'0'
                        }
                    ]
                },
                chartDataB: {
                    columns: ['日期','间夜数'],
                    rows:[
                        {
                            日期:this.getDate(0),
                            间夜数:'0'
                        }
                    ]
                },
                calendarA: {
                    show: false,
                    start: this.getDate(-90),
                    begin: this.getDate(0),
                    end: this.getDate(6),
                    select: (begin, end) => {
                        if (!begin) {
                            // this.calendarA.show = false;
                            return;
                        }

                        this.calendarA.begin = begin;
                        this.calendarA.end =  this.dateAdd(begin,this.dayNumA);
                        this.StartA = begin;
                        this.End = this.dateAdd(begin,this.dayNumA);
                        this.$nextTick(function () {
                            this.calendarA.show = false;
                            this.initData('A')
                            // this.changeFilter();
                        });
                    }
                },
                calendarB: {
                    show: false,
                    start: this.getDate(-90),
                    begin: this.getDate(-6),
                    end: this.getDate(0),
                    select: (begin, end) => {
                        if (!begin) {
                            // this.calendarB.show = false;
                            return;
                        }

                        this.calendarB.begin = this.dateMinus(begin,this.dayNumB);
                        this.calendarB.end =  begin;
                        this.StartB = begin;
                        this.End = this.dateAdd(begin,this.dayNumB);
                        this.$nextTick(function () {
                            this.calendarB.show = false;
                            this.initData('B')
                            // this.changeFilter();
                        });
                    }
                },
                //  A 代表是入住报表，B代表是预定报表
                StartA:this.getDate(0),
                typeA: 'NRC',
                dayNumA:7,
                listA:[],
                isLoadingA:false,
                isNoDataA:false,
                StartB:this.getDate(0),
                typeB: 'NRC',
                dayNumB:7,
                listB:[],
                isLoadingB:false,
                isNoDataB:false,
            }
        },
        watch:{
            dayNumA(key){
                this.initData('A');
                this.calendarA.end = this.dateAdd(this.StartA,this.dayNumA)
            },
            dayNumB(key){
                this.initData('B');
                this.calendarB.begin = this.dateMinus(this.StartB,this.dayNumB)
            }
        },
        mounted() {
            this.initData('A');
            this.initData('B');
            document.title='日看板---云境';
        },
        methods: {
            checkType(type,datetype){
                if(datetype == 'A'){
                    this.typeA = type;
                    this.formatChart(this.listA,datetype,type)
                }else{
                    this.typeB = type;
                    this.formatChart(this.listB,datetype,type)
                }
            },
            manageData(list,type){
                var row = [];
                var column = []
                if(type === 'NRC'){
                    for(let i = 0; i < list.length; i++){
                        var arr = {
                            日期: this.formatDay(list[i].Tag),
                            间夜数: list[i].NRC
                        }
                        row.push(arr)
                    }
                    column = ['日期','间夜数'];
                }else if(type === 'OrderCount'){
                    for(let i = 0; i < list.length; i++){
                        var arr = {
                            日期: this.formatDay(list[i].Tag),
                            订单数: list[i].OrderCount
                        }
                        row.push(arr)
                    }
                    column = ['日期','订单数'];
                }else if(type === 'Amount'){
                    for(let i = 0; i < list.length; i++){
                            var arr = {
                            日期: this.formatDay(list[i].Tag),
                            订单金额: list[i].Amount
                        }
                        row.push(arr)
                    }
                    column = ['日期','订单金额'];
                }
                var data = {
                    row:row,
                    column:column,
                }
                return data
            },
            //补全日期
            completionDate(lists,start,days){
                var list = lists;
                if(list.length == days){
                    for(let j=0; j<list.length; j++){
                        list[j].Tag = this.formatDate(list[j].Tag)
                    }
                }else{
                    for(let i=0; i<days; i++){
                        var a = true;
                        for(let j=0; j<list.length; j++){
                            if(this.formatDate(list[j].Tag) == this.dateAdd(start,i)){
                                a = false;
                                list[j].Tag = this.formatDate(list[j].Tag)
                            }
                        }
                        if(a){
                            var arr = {
                                Amount: 0,
                                NRC: 0,
                                OrderCount: 0,
                                Tag: this.dateAdd(start,i)
                            }
                            list.splice(i,0,arr)
                        }
                    }
                }
                list.sort(function(a,b){
                    return new Date(a.Tag) - new Date(b.Tag);
                })
                return list
            },

            formatChart(list,datetype,type){ //格式化报表格式数据
                if(datetype == 'A'){
                    this.isNoDataA = false;
                    var data = this.manageData(list,type)
                    if(data.row.length == 0){
                        this.isNoDataA = true
                    }
                    this.chartDataA = {
                        columns: data.column,
                        rows:data.row
                    }
                }else{
                    this.isNoDataB = false
                    var data = this.manageData(list,type)
                    if(data.row.length == 0){
                        this.isNoDataB = true
                    }
                    this.chartDataB = {
                        columns: data.column,
                        rows:data.row
                    }
                }
            },
            formatDay(v){  //格式化时间MM-dd
                var data = new Date(v);
                var month =  data.getUTCMonth()+1;
                var day = data.getUTCDate();

                if(month<10){month='0'+month};
                if(day<10){day='0'+day};
                return month+'-'+day;
            },
            dateMinus(startDate,addDateNum) {
                const date = new Date(startDate);
                date.setDate(date.getDate() - (addDateNum-1));
                const resultDate = this.dateToYMDline(date);
                return resultDate;
            },
            dateAdd(startDate,addDateNum) {
                const date = new Date(startDate);
                date.setDate(date.getDate() + (addDateNum-1));
                const resultDate = this.dateToYMDline(date);
                return resultDate;
            },
            // dateMinus(startDate,addDateNum){ //计算多少天前的日期
            //     startDate = new Date(startDate);
            //     startDate = +startDate - 1000 * 60 * 60 * 24 * addDateNum;
            //     startDate = new Date(startDate);
            //     var m = (startDate.getMonth() + 1)<10?'0'+(startDate.getMonth() + 1):startDate.getMonth() + 1;
            //     var d = startDate.getDate()<10?'0'+startDate.getDate():startDate.getDate();
            //     var nextStartDate = startDate.getFullYear() + "-" + m + "-" + d;
            //     return nextStartDate;
            // },
            // dateAdd(startDate,addDateNum) {     //计算多少天后的日期
            //     startDate = new Date(startDate);
            //     startDate = +startDate + 1000 * 60 * 60 * 24 * addDateNum;
            //     startDate = new Date(startDate);
            //     var m = (startDate.getMonth() + 1)<10?'0'+(startDate.getMonth() + 1):startDate.getMonth() + 1;
            //     var d = startDate.getDate()<10?'0'+startDate.getDate():startDate.getDate();
            //     var nextStartDate = startDate.getFullYear() + "-" + m + "-" + d;
            //     return nextStartDate;
            // },
            formatDate(list){
                    return list.charAt(0)+list.charAt(1)+list.charAt(2)+list.charAt(3)+'-'+list.charAt(4)+list.charAt(5)+'-'+list.charAt(6)+list.charAt(7);

            },
            initData(datetype){
                var that = this;
                if(datetype == 'A'){
                    that.isLoadingA = true
                    var params = {
                        Start:that.StartA,
                        End:that.dateAdd(that.StartA,this.dayNumA),
                        DateType:1,
                        GroupType:0,
                    }
                    that.postRequest({
                        url:that.Api.getReport,
                        params:params
                    }).then(res => {
                        that.isLoadingA = false;
                        if (res && res.IsSuccess) {
                            that.listA = this.completionDate(res.Result,that.StartA,this.dayNumA);
                            that.formatChart(that.listA,'A',that.typeA)
                        } else {

                        }
                    })
                }else{
                    that.isLoadingB = true;
                    var params = {
                        Start:that.dateMinus(that.StartB,this.dayNumB),
                        End:that.StartB,
                        DateType:0,
                        GroupType:0,
                    }
                    that.postRequest({
                        url:that.Api.getReport,
                        params:params
                    }).then(res => {
                        that.isLoadingB = false;
                        if (res && res.IsSuccess) {
                            // that.listB = res.Result
                            that.listB = this.completionDate(res.Result,that.dateMinus(that.StartB,this.dayNumB),this.dayNumB);
                            that.formatChart(that.listB,'B',that.typeB)
                        } else {
                            // $state.complete();
                        }
                    })
                }

            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/report/ReportDay.vue